import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DiamondIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M6.158 5.48A1 1 0 017.012 5h1.315l-1.09 4H4.014l2.143-3.52zM9.31 9L10.4 5h3.2l1.09 4H9.31zm5.214 2H9.477L12 17.307 14.523 11zm-.333 6.218L16.677 11h3.372l-5.86 6.218zM16.764 9l-1.091-4h1.314a1 1 0 01.854.48L19.985 9h-3.221zM3.95 11h3.372l2.488 6.218L3.95 11zm3.061-8A3 3 0 004.45 4.44L1.939 8.565a3 3 0 00.379 3.617l7.498 7.959a3 3 0 004.367 0l7.5-7.958a3 3 0 00.378-3.618L19.55 4.44A3 3 0 0016.987 3H7.012z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
DiamondIcon.isCarinaIcon = true;
export default DiamondIcon;
